import { ecritureContrastee } from '../../../lib/generique';
import { Pressable, View, Text } from 'react-native';
import styles from '../../CalendrierDetail/CalendrierDetail.styles';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import { RenderItemAgendaProps } from '../CalendrierUniversel.types';
import { getStatusColor, getStatusIcon } from '../../StatutDemande/StatutDemande.constants';

export default function RenderItemAgenda({item, onEventPress}: RenderItemAgendaProps) {
  const contraste = ecritureContrastee(item.couleur);
  const statut = item.type === 'absence' ? 'acceptee' : 'enCours'
  const icon = getStatusIcon(statut)
  const color = getStatusColor(statut)
  return (
    <Pressable onPress={() => onEventPress(item)} testID={`BT_${item.date.format('YYYY-MM-DD')}_${item.index}`}>
      <View style={[styles.containerRow, styles.mainContainer, { marginTop: 5 }]}>
        <View style={styles.containerRow}>
          <View style={[styles.pastille, {backgroundColor: contraste, borderColor: item.couleur}]}>
            <MaterialCommunityIcons name={item.icon} size={30} color={item.couleur} />
          </View>
          <View>
            <Text>{item.libelle}</Text>
          </View>
        </View>
        <View style={styles.containerRow}>
          <Text>{typeof item.duree === 'string' ? item.duree : item.duree?.texte}</Text>
          <View style={[styles.statusBadge, { backgroundColor: color }]}>
            <MaterialCommunityIcons
              name={icon}
              size={20}
              color="white"
            />
          </View>
          <View>
            <Text>{item.heureDebut}</Text>
            <Text>{item.heureFin}</Text>
          </View>
        </View>
      </View>
    </Pressable>
  )
}
